// eslint-ignore
export default 
`<Toggle v-model="value" right-label="Small" size="sm"/>
<Toggle v-model="value" right-label="Medium"/>
<Toggle v-model="value" right-label="Large" size="lg"/>


export default {
  components: { Toggle },

  data() {
    return { 
      value: false
    }
  }
}`;